/**
 * Contact & Conversion Factories
 * WhatsApp, lead generation, CTAs, phone calls
 */

import { gtagEvent } from '../utils/gtag';
import { fbqEvent } from '../utils/fbq';
import { getSessionUtm } from '../utmCapture';

/**
 * Registra um lead qualificado (qualify_lead) — usado para Google Ads Performance Max
 */
function trackQualifyLead(
  leadType: 'whatsapp_click' | 'newsletter_signup' | 'leadmagnet_download' | 'booking_click',
  source?: string
): void {
  const params = {
    lead_type: leadType,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    source,
  };
  gtagEvent('qualify_lead', params);
}

/**
 * Clique em botão/link WhatsApp
 */
export function trackWhatsAppClick(provider: string, source?: string): void {
  const params = {
    provider,
    source: source || '',
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    ...getSessionUtm(),
  };

  gtagEvent('whatsapp_click', params);
  fbqEvent('Contact', { content_name: provider });

  // Dispara qualify_lead para Google Ads Performance Max
  trackQualifyLead('whatsapp_click', source);
}

/**
 * Submit de formulário / newsletter
 */
export function trackGenerateLead(formType: string, source?: string): void {
  const params = {
    form_type: formType,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    ...getSessionUtm(),
  };

  gtagEvent('generate_lead', params);
  fbqEvent('Lead', { content_name: formType });

  // Dispara qualify_lead para Google Ads Performance Max
  trackQualifyLead('newsletter_signup', source);
}

/**
 * Clique para ligar (phone call)
 */
export function trackPhoneCall(phoneNumber: string, source?: string): void {
  const params = {
    phone_number: phoneNumber,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    source: source || 'contact_page',
    ...getSessionUtm(),
  };

  gtagEvent('phone_call', params);
}

/**
 * Lead magnet download
 */
export function trackLeadMagnetDownload(resource: string, source: string, language: string): void {
  const params = {
    resource,
    source,
    language,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    ...getSessionUtm(),
  };

  gtagEvent('leadmagnet_download', params);
  fbqEvent('Lead', { content_name: resource });

  // Dispara qualify_lead para Google Ads Performance Max
  trackQualifyLead('leadmagnet_download', source);
}

/**
 * Clique genérico em CTA
 */
export function trackCtaClick(ctaText: string, ctaLocation: string, destination?: string): void {
  const params = {
    cta_text: ctaText,
    cta_location: ctaLocation,
    destination,
    ...getSessionUtm(),
  };

  gtagEvent('cta_click', params);
}

/**
 * Booking / reserva click
 */
export function trackBookingClick(
  provider: string,
  entityType: string,
  entityName: string,
  entityId: string,
  price?: number,
  currency?: string
): void {
  const params = {
    provider,
    entity_type: entityType,
    entity_name: entityName,
    entity_id: entityId,
    price,
    currency,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    ...getSessionUtm(),
  };

  gtagEvent('booking_click', params);
  fbqEvent('InitiateCheckout', {
    content_name: entityName,
    value: price,
    currency: currency || 'BRL',
  });

  // Dispara qualify_lead para Google Ads Performance Max
  trackQualifyLead('booking_click', provider);
}
